import * as React from 'react';
import { CardsManagerCallbacks } from '../CardsManager/CardsManager';
import MediaQuery from 'react-responsive';
import './AddBookFloat.css';
import { MOBILE_MAX_WIDTH } from '../../utils';
import FindBook from '../Header/FindBook/FindBook';
import SearchIcon from '@material-ui/icons/Search';

interface Props {
	callbacks: CardsManagerCallbacks;
}

const AddBookFloat: React.FC<Props> = props => {
	return (
		<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
			<FindBook
				callbacks={props.callbacks}
				withoutInitial={true}
				dummyRender={(onClick) => (
					<div className="addBookFloat" onClick={onClick}>
						<SearchIcon />
						Найти книгу
					</div>
				)}
			/>
		</MediaQuery>
	);
};

export default AddBookFloat;
